import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import * as endpoints from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';

import { DictionaryActions } from '@/store/actions';

const { getDictionary } = DictionaryActions;

export function* getDictionarySaga() {
  yield put({ type: getDictionary.types.START });

  try {
    const { data: respData } = yield axios.get(endpoints.DICTIONARY_GET);

    yield put({
      type: getDictionary.types.SUCCESS,
      payload: {
        data: respData,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getDictionary.types.FAIL,
    });
  }
}

export default getDictionarySaga;
